<template>
  <div class="home">
    <van-cell class="actValue" title="来访预约">
      <span @click="toInvite">邀约访客</span>
    </van-cell>
    <p class="part_title">查询您要找的人</p>
    <div class="_search">
      <div class="search_wrap">
        <van-field v-model.trim="phone" class="hasinput" placeholder="输入被访人电话号码" />
        <van-button type="info" @click="handleSearch">查询</van-button>
      </div>
      <div class="search_result">
        <p v-if="emptyMsg" class="empty">
          <van-icon name="warning" />
          {{ emptyMsg }}
        </p>
        <div v-if="staffInfo" class="_result">
          <p v-if="staffInfo.name">
            <span>{{ staffInfo.name }}</span>
          </p>
          <p v-if="staffInfo.company">
            <span>公司：</span>
            {{ staffInfo.company }}
          </p>
          <p v-if="staffInfo.edifice">
            <span>大厦：</span>
            {{ staffInfo.edifice }}
          </p>
          <p v-if="staffInfo. floor">
            <span>楼层：</span>
            {{ staffInfo. floor }}
          </p>
        </div>
      </div>
    </div>
    <p class="part_title">选择来访事由及时间</p>
    <van-cell required class="actValue" title="来访事由">
      <span @click="showCause = true">{{ dataFrom.reason }}</span>
    </van-cell>
    <van-cell required class="actValue" title="来访时间">
      <span @click="showPicker =true">{{ dataFrom.visitDate }}</span>
    </van-cell>
    <van-cell required class="actValue" title="离访时间">
      <span @click="showTwoPicker =true">{{ dataFrom.endVisitDate }}</span>
    </van-cell>
    <van-form @submit="handleAppointment">
      <van-field v-for="item in extraFields" :key="item.id" v-model.trim="dataFrom[item.fieldName]" :required="item.must" :rules="[{ required: item.must }]" class="hasinput" :label="item.displayName" :placeholder="`请输入${item.displayName}`" />
      <van-button
        :disabled="!dataFrom.beVisitStaffId && clickFlag"
        class="sub_btn"
        type="info"
        native-type="submit"
      >提交预约申请</van-button>
    </van-form>
    <div v-show="showCause" class="piker_wrap" @click="showCause = false">
      <ul class="piker_content" @click.stop>
        <li
          v-for="(item,index) in reasonList"
          :key="index"
          :class="{active:active==index}"
          @click="changeReason(item,index)"
        >{{ item }}</li>
      </ul>
      <div class="cancel" @click="onCancel">取消</div>
    </div>
    <van-dialog v-model="showDialog" class="new—dialog" title="温馨提示" show-cancel-button confirm-button-text="预约" :before-close="beforeClose" message-align="left">
      <div class="van-dialog__message">
        <p>您已登记于{{ visitorMsg.visitDate }}访问 {{ visitorMsg.beVisitCompanyName }} {{ visitorMsg.beVisitStaffName }}，当前状态:{{ visitorMsg.visitorStatusName }}</p>
        <p>继续预约将结束上述访问（取消上述访问），是否预约？</p>
        <p class="tips">*{{ visitorMsg.message }}</p>
      </div>

    </van-dialog>
    <van-popup v-model="showPicker" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :min-date="minDate"
        :formatter="formatter"
        @confirm="timeConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showTwoPicker" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="nextTwoDate"
        type="datetime"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="timeTwoConfirm"
        @cancel="showTwoPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment';
import { Appointment, getReasons, searchAppointment, cancelAppointment } from '@/api/home';
import { GetUserInfo } from '@/api/user';
export default {
  name: 'Home',
  data() {
    return {
      reasonList: [],
      extraFields: [],
      userInfo: {}, // 用户信息，用于邀约访客判断是否已认证为员工
      phone: '',
      showDialog: false,
      clickFlag: true, // 预约申请按钮只点击一次
      dataFrom: {
        reason: '',
        visitDate: '',
        carNumber: '',
        beVisitStaffId: ''
      },
      visitorMsg: {},
      showCause: false,
      staffInfo: {},
      active: 0,
      emptyMsg: '',
      minHour: 10,
      maxHour: 20,
      empty: false,
      showPicker: false,
      showTwoPicker: false,
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: '',
      nextTwoDate: ''
    };
  },
  created() {
    this.setTime();
    this.getReasonList();
    this.getUserInfo();
  },
  methods: {
    filter(type, options) {
      if (type === 'minute') {
        return options.filter(option => option % 1 === 0);
      } else {
        return options;
      }
    },
    formatter(type, value) {
      switch (type) {
        case 'year':
          value = `${value}年`;
          break;
        case 'month':
          value = `${value}月`;
          break;
        case 'day':
          value = `${value}日`;
          break;
        case 'hour':
          value = `${value}时`;
          break;
        case 'minute':
          value = `${value}分`;
          break;
      }
      return value;
    },
    convertDateFormat(dateString) {
      const date = new Date(dateString);

      // 提取日期和时间的各个部分
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 补0
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      // 返回新的格式 "YYYY-MM-DD HH:mm"
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    handleSearch() {
      if (!this.phone) {
        this.$toast({
          message: '请输入被访人电话号码'
        });
        return;
      }
      const data = {
        phone: this.phone
      };
      searchAppointment(data).then(res => {
        if (res.code !== 200) {
          this.emptyMsg = res.message;
          this.staffInfo = {};
        } else {
          this.emptyMsg = '';
          this.staffInfo = res.data;
          this.dataFrom.beVisitStaffId = res.data.id;
        }
      });
    },
    beforeClose(action, done) {
      // done(false) // 不关闭弹框
      if (action === 'confirm') {
        const data = {
          id: this.visitorMsg.id,
          status: 'CANCEL'
        };
        cancelAppointment(data).then(res => {
          this.clickFlag = true;
          this.handleAppointment();
          // done()
        });
      } else if (action === 'cancel') {
        done(); // 关闭
        this.clickFlag = true;
      }
    },
    // 设置默认时间为当前时间的下一个整点
    setTime() {
      const now = new Date();
      now.setMinutes(0, 0, 0); // 清除分钟和秒，保持整点
      const nextHour = new Date(now.getTime() + 60 * 60 * 1000); // 当前时间加一小时
      const nextTwoHour = new Date(nextHour.getTime() + 2 * 60 * 60 * 1000); // 当前时间加三小时

      // 使用格式化函数转换为 iOS 兼容的字符串格式
      this.dataFrom.visitDate = this.formatDate(nextHour);
      this.dataFrom.endVisitDate = this.formatDate(nextTwoHour);
      this.currentDate = nextHour;
      this.nextTwoDate = nextTwoHour;

      // 保证 minDate 和 maxDate 是 Date 对象
      this.minDate = new Date(); // 当前时间作为最小时间
      this.maxDate = new Date(new Date().setHours(23, 59, 0, 0));
    },
    // 格式化日期为 YYYY/MM/DD HH:mm 的格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 补0
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      // 返回iOS兼容的字符串格式
      return `${year}/${month}/${day} ${hours}:${minutes}`;
    },
    timeConfirm(val) {
      const now = new Date().getTime();
      const selectedTime = new Date(val).getTime();

      if (selectedTime < now) {
        this.$toast({
          message: '来访时间不能在当前时间之前'
        });
        return;
      }

      // 格式化时间并更新dataFrom
      this.dataFrom.visitDate = this.formatDate(new Date(val));
      this.showPicker = false;

      // 检查离访时间是否早于来访时间，自动调整离访时间
      const diff = new Date(this.dataFrom.endVisitDate).getTime() - new Date(this.dataFrom.visitDate).getTime();
      if (diff <= 0) {
        const nextTwoHour = new Date(new Date(val).getTime() + 2 * 60 * 60 * 1000);
        this.dataFrom.endVisitDate = this.formatDate(nextTwoHour);
        this.nextTwoDate = nextTwoHour;
      }

      // 更新 maxDate 为当天的 23:59，并保证它是一个 Date 对象
      this.maxDate = new Date(new Date(val).setHours(23, 59, 0, 0));
    },
    timeTwoConfirm(val) {
      const visitTime = new Date(this.dataFrom.visitDate).getTime();
      const endVisitTime = new Date(val).getTime();

      // 确保离访时间在来访时间之后
      if (endVisitTime <= visitTime) {
        this.$toast({
          message: '离访时间不能在来访时间之前'
        });
        return;
      }

      // 更新离访时间
      this.dataFrom.endVisitDate = this.formatDate(new Date(val));
      this.showTwoPicker = false;
    },
    changeReason(item, i) {
      this.active = i;
      this.dataFrom.reason = item;
      this.showCause = false;
    },
    getReasonList() {
      getReasons({}).then(res => {
        this.reasonList = res.data.reasons;
        this.extraFields = res.data.extraFields.ASK || [];
        this.dataFrom.reason = this.reasonList[0];
        this.appointmentInfo();
      });
    },
    onCancel() {
      this.showCause = false;
    },
    handleAppointment() {
      if (!this.clickFlag) return;
      this.clickFlag = false;
      const data = {
        ...this.dataFrom,
        visitDate: this.convertDateFormat(this.dataFrom.visitDate),
        endVisitDate: this.convertDateFormat(this.dataFrom.endVisitDate)
      }
      Appointment(data).then(res => {
        if (res.code === 200) {
          this.$router.push({ path: '/appointmentSuc' });
        } else if (res.code === 50001) {
          this.visitorMsg = res.data;
          this.visitorMsg.message = res.message;
          this.showDialog = true;
          this.clickFlag = true;
        } else {
          this.$dialog.alert({
            title: '温馨提示',
            message: res.message,
            confirmButtonText: '我知道了'
          });
          this.clickFlag = true;
        }
      }).catch(() => {
        this.clickFlag = true;
      });
    },
    toInvite() {
      if (this.userInfo.staff) {
        this.$router.push({ path: '/invite' });
        return;
      }
      this.$router.push({ path: '/unverified' });
    },
    getUserInfo() {
      const data = {};
      GetUserInfo(data).then(res => {
        res.data ? this.userInfo = res.data : this.$router.push({ name: 'bind' });
      });
    },
    appointmentInfo() {
      if (this.$route.params.id && sessionStorage.getItem('appointmentInfo')) {
        const appointmentInfos = JSON.parse(sessionStorage.getItem('appointmentInfo'));
        this.dataFrom.reason = appointmentInfos.reason;
        this.active = this.reasonList.indexOf(this.dataFrom.reason);

        const d = new Date().getTime();
        const formattedVisitDate = appointmentInfos.visitDate.replace(/-/g, '/').replace(' ', 'T');
        const d1 = new Date(formattedVisitDate).getTime();

        if (d <= d1) {
          this.dataFrom.visitDate = formattedVisitDate; // 使用替换后的格式
          this.currentDate = new Date(formattedVisitDate);
        }

        this.phone = appointmentInfos.beVisitStaffPhone;
        if (this.phone) {
          this.handleSearch();
        }
      }
    }
  }
};
</script>

<style lang="less">
@import './style/home.less';
</style>
